import { configureStore } from './configure-store'
import createHistory from 'history/createHashHistory'

export const history = createHistory()
const store = configureStore(history)

export default store
